import Title from "../../components/title/Title";
import { useEffect, useState } from "react";
import axios from "axios";

import arrow from "../../assets/images/right-arrow.svg";

import ListItem from "../../components/listItem/ListItem";

import loadingImage from "../../assets/images/loading.gif";

import "./Students.css";
import { useHistory } from "react-router-dom";

const Students = () => {
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();

  useEffect(() => {
    getStudents();
  }, []);

  const onInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const getStudents = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/actions/students", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setTimeout(() => {
        setLoading(false);
        setStudents(response.data);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const onStudentClick = (student) => {
    console.log(student);
    sessionStorage.setItem(
      "studentName",
      `${student.PrivateName} ${student.FamilyName}`
    );
    history.push(`/dashboard/students/${student.RiderId}`);
  };

  return (
    <div id="students">
      <Title text="תלמידים" />
      {loading ? (
        <img id="loading" src={loadingImage} alt="" />
      ) : (
        <div id="content">
          <input
            type="text"
            value={searchValue}
            onChange={onInputChange}
            placeholder="חיפוש תלמיד לפי שם"
          />
          <ul>
            {students
              .filter(
                (student) =>
                  student.PrivateName.includes(searchValue) ||
                  student.FamilyName.includes(searchValue)
              )
              .map((student, index) => {
                return (
                    <li
                    key={student.RiderId}
                    onClick={() => {
                      onStudentClick(student);
                    }}
                  >
                    <span>
                    {student.PrivateName} {student.FamilyName}
                    </span>
                    <img src={arrow} alt="" />
                  </li>
                  

                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Students;
